import {ApiRequest} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {IUserProfileBase} from "../define";
import {UserLoginResponse} from "./user-login.protocol";

export const ThirdPartyLoginUrl = `/do_3rd_party_login`;
export const ThirdPartyLoginMethod = ERequestType.TYPE_POST;

export interface ThirdPartyLoginBody extends ApiRequest {
	type: string;
	platform: string;
	
	// all
	token: string;
	
	// twitter
	secret?: string;
	
	// weixin
	openId?: string;
}

export interface ThirdPartyLoginResponse<IProfile extends IUserProfileBase> extends UserLoginResponse<IProfile> {
}
